const currencies = [
	{ label: "RUB", value: "RUB" },
	{ label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" },
  { label: "XTR", value: "XTR" },
]

export {
  currencies
}
export default currencies
